import {UserGranredAuthorityName} from "../../router/const/AllPermitions";

export class FeatureAccessLevel {
    id?: number;
    authorityName: UserGranredAuthorityName;
    status?: boolean;
}

export class AccessLevelToggle extends FeatureAccessLevel {
    title: string;
    icon: string;
}

export function mapAccessTogglesGui(toggles: FeatureAccessLevel[]) {
    return toggles // todo temporary
        .filter(dataToggle => dataToggle.authorityName != UserGranredAuthorityName.MFA_AUTH_REQUEST)
        .filter(dataToggle => dataToggle.authorityName != UserGranredAuthorityName.REFRESH_ACCESS)
        .map(dataToggle => {
                let guiToggle = APPLICATION_ACCESS_LEVEL_TOGGLES().find(guiToggle => guiToggle.authorityName === dataToggle.authorityName);
                if (guiToggle == null)
                    throw Error("Did not find a match for a toggle with authorityName: " + dataToggle.authorityName);
                return Object.assign(dataToggle, guiToggle);
            }
        )
}


export const APPLICATION_ACCESS_LEVEL_TOGGLES = (): AccessLevelToggle [] => [
    {
        authorityName: UserGranredAuthorityName.SCHEDULED_TASKS,
        title: 'Scheduled Tasks',
        icon: '/app/images/icons/timer.svg'
    },
    {
        authorityName: UserGranredAuthorityName.OPPORTUNITIES,
        title: 'Opportunities',
        icon: '/app/images/icons/bell.svg',
    },
    {
        authorityName: UserGranredAuthorityName.CAMPAIGNS,
        title: 'Campaigns',
        icon: '/app/images/icons/exclamation_mark.svg'
    },
    {
        authorityName: UserGranredAuthorityName.LOGGING,
        title: 'Logging',
        icon: '/app/images/icons/archive.svg',
    },
    {
        authorityName: UserGranredAuthorityName.MAIL_LOGGING,
        title: 'Mail Logging',
        icon: '/app/images/icons/archive.svg',
    },
    {
        authorityName: UserGranredAuthorityName.LOGGING_FUNDED,
        title: 'Syncing',
        icon: '/app/images/icons/dollar.svg',
    },
    {
        authorityName: UserGranredAuthorityName.CALCULATIONS,
        title: 'Calculators',
        icon: '/app/images/icons/ruler.svg'
    },
    {
        authorityName: UserGranredAuthorityName.CUSTOMERS,
        title: 'Customers',
        icon: '/app/images/icons/face.svg',
    },
    {
        authorityName: UserGranredAuthorityName.LEADS,
        title: 'Leads',
        icon: '/app/images/icons/face.svg',
    },
    {
        authorityName: UserGranredAuthorityName.PARTNERS,
        title: 'Partners',
        icon: '/app/images/icons/face.svg',
    },
    {
        authorityName: UserGranredAuthorityName.BRANCH,
        title: 'Branch',
        icon: '/app/images/icons/branch.svg'
    },
    {
        authorityName: UserGranredAuthorityName.REDIRECTS,
        title: 'Redirects',
        icon: 'app/images/icons/undo.svg'
    },
    {
        authorityName: UserGranredAuthorityName.USERS,
        title: 'Users',
        icon: '/app/images/icons/supervisor.svg'
    },
    {
        authorityName: UserGranredAuthorityName.STATISTICS,
        title: 'Statistics',
        icon: '/app/images/icons/chart.svg',
    },
    {
        authorityName: UserGranredAuthorityName.TRANSFER_LO,
        title: 'Transfer LO',
        icon: "/app/images/icons/arrows_up_down.svg"
    },
    {
        authorityName: UserGranredAuthorityName.MANUAL_IMPORT,
        title: 'Manual customers import',
        icon: "/app/images/icons/import_customers.svg"
    },
    {
        authorityName: UserGranredAuthorityName.TEMPORARY_DELETE_CUSTOMER,
        title: 'Temporary delete customer',
        icon: "/app/images/icons/delete_outline.svg"
    },
    {
        authorityName: UserGranredAuthorityName.PERMANENTLY_DELETE_CUSTOMER,
        title: 'Permanently delete customer',
        icon: "/app/images/icons/delete_forever_outline.svg"
    },
    {
        authorityName: UserGranredAuthorityName.CSV_EXPORT,
        title: 'Csv Export',
        icon: "/app/images/icons/download.svg"
    },
    {
        authorityName: UserGranredAuthorityName.MORPH,
        title: 'Morph',
        icon: "/app/images/icons/supervisor.svg"
    },
    {
        authorityName: UserGranredAuthorityName.AI_EMAIL_GENERATE,
        title: 'Ai Email Generate',
        icon: "/app/images/icons/ai_email_generate.svg"
    },
    {
        authorityName: UserGranredAuthorityName.OPPORTUNITY_CUSTOMER_MAILING,
        title: 'Opportunity customer mailing',
        icon: "/app/images/icons/mailing.svg"
    },
    {
        authorityName: UserGranredAuthorityName.OPPORTUNITY_EMPLOYEE_MAILING,
        title: 'Opportunity loan officer mailing',
        icon: "/app/images/icons/mailing.svg"
    },
    {
        authorityName: UserGranredAuthorityName.OPPORTUNITY_PHYSICAL_MAILING,
        title: 'Physical letter mailing',
        icon: "/app/images/icons/postcard.svg"
    },
    {
        authorityName: UserGranredAuthorityName.SENDING_SMS,
        title: 'Sending sms',
        icon: "/app/images/icons/phone.svg"
    },

];
